export enum ForgotPasswordSteps {
    email,
    emailVerification,
    setPassword,
}

export interface ForgotPasswordStateModel {
    email:{
        email: string
    }
    emailVerification: {
      email: string,
      emailVerified: boolean
    },
    setPassword: {
      password: string,
      confirmPassword: string
    }
    currentStep: ForgotPasswordSteps,
    temporaryToken: string
}